<template>
  <div class="main-footer">
    <span
      v-tooltip="`${questions.length} question(s)`"
      class="cursor-pointer"
    >
      <AhaSvg
        size="lg"
        name="question"
        class="mr-1 text-base-0 relative bottom-3px"
      />
      <span class="mr-4">
        <AhaFormatter
          type="number"
          :value="questions.length"
        />
      </span>
    </span>

    <span
      v-tooltip="`${presentation.onlineCount} live participant(s) right now`"
      class="relative cursor-pointer bottom-1px"
    >
      <AhaSvg
        name="user-solid"
        view-box="0 0 16 17"
        class="mr-1 text-base-0 relative bottom-1px"
      />
      <span :class="`online-status ${presentation.onlineStatus}`" />
      <span class="">
        <AhaFormatter
          type="number"
          :value="presentation.onlineCount"
        />
        <span v-if="presentation.limit !== 10000">/<AhaFormatter
          type="number"
          :value="presentation.limit"
        /></span>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    presentation: {
      type: Object,
      default: () => ({}),
    },
    questions: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.main-footer {
  @apply flex justify-center sm:justify-end items-center;
  @apply px-3 text-md14-h18 text-base-0 py-3;
}

.online-status {
  width: 7px;
  height: 7px;
  position: absolute;
  left: 10px;
  bottom: -1px;
  border-radius: 50%;
  border: 1px solid #fff;

  --tw-bg-opacity: 1;

  @apply bg-green-50;

  &.green {
    @apply bg-green-50;
  }

  &.warning {
    background-color: #f90;
  }

  &.danger {
    background-color: #f00;
  }
}

.bottom-3px {
  bottom: 2px;
}

.bottom-1px {
  bottom: 1px;
}

.bottom-2px {
  bottom: 1px;
}
</style>
